import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserPrincipalService } from '@app-core/providers/user-principal.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageSwitcherComponent {

  private availableLangs_ = this.translate.getLangs().map(lang => (
    {
      name: lang,
      icon: `locales:${lang}`,
      caption: lang === 'ru' ? 'Русский' : 'English'
    }
  ));


  constructor(private translate: TranslateService, private userPrincipal: UserPrincipalService) {
  }


  public get current(): string {
    return `locales:${this.userPrincipal.language}`;
  }

  public get availableLanguages(): { name: string, icon: string }[] {
    return this.availableLangs_;
  }

  public onLanguageChange(lang: string): void {
    this.userPrincipal.language = lang;
  }

}
